/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserUserListResponse } from './RevisdomAPIViewModelsUserUserListResponse';
import {
    RevisdomAPIViewModelsUserUserListResponseFromJSON,
    RevisdomAPIViewModelsUserUserListResponseFromJSONTyped,
    RevisdomAPIViewModelsUserUserListResponseToJSON,
    RevisdomAPIViewModelsUserUserListResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserUserListResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1UserListResponse
 */
export interface ApiResponse1UserListResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1UserListResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1UserListResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsUserUserListResponse}
     * @memberof ApiResponse1UserListResponse
     */
    data?: RevisdomAPIViewModelsUserUserListResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1UserListResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1UserListResponse interface.
 */
export function instanceOfApiResponse1UserListResponse(value: object): value is ApiResponse1UserListResponse {
    return true;
}

export function ApiResponse1UserListResponseFromJSON(json: any): ApiResponse1UserListResponse {
    return ApiResponse1UserListResponseFromJSONTyped(json, false);
}

export function ApiResponse1UserListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1UserListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsUserUserListResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1UserListResponseToJSON(json: any): ApiResponse1UserListResponse {
    return ApiResponse1UserListResponseToJSONTyped(json, false);
}

export function ApiResponse1UserListResponseToJSONTyped(value?: ApiResponse1UserListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsUserUserListResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

